import { Book } from './book';

export const BOOK : Book[] =  [
    {
      id: "fur_money",
      name_ru: "Меховые деньги Древней Руси XI-XIII вв.",
      centuries: ['XI', 'XII', 'XIII'],
      authors: ['Гулецкий Д.В.', 'Дорошкевич Н.А.'],
      ISBN: "978-985-7157-88-4",
      pages: 280,
      published: "Минск 2018",
      pdf: null,
      description: "Издание посвящено углубленному изучению феномена древнерусских меховых денег, освещённого в письменных источниках и свидетельствах иностранцев XI–XV вв. Это уникальное в мировой истории явление связано с использованием известных по археологическим находкам свинцовых пломб того же периода. На основании существующих к настоящему времени научных публикаций составлен каталог атрибутированных памятников древнерусской «малой сфрагистики»."
    },
    {
      id: "hp",
      name_ru: "Русские средневековые монеты",
      centuries: ['X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI'],
      authors: ['Гулецкий Д.В.', 'Петрунин К.М.'],
      ISBN: "978-5-902271-21-5",
      pages: 660,
      published: "Москва 2017",
      pdf: "http://ruslitvaorda.ru/hp_2017.pdf",
      description: "Издание «Русские средневековые монеты» посвящено всему периоду средневековой истории Руси, или, если говорить точнее - всему княжескому периоду от первых киевских монет до венчания Ивана Васильевича Грозного на царство. В книгу вошёл также значительный массив платёжных слитков, игравших ключевую роль в русском денежном обращении XII-XV столетий. До настоящего времени информация об этих необычных памятниках нумизматики была разобщена и труднодоступна массовому читателю. Заметно расширена классификация подражаний и надчеканов, выпускавшихся в русских княжествах, исследованы основы (чаще всего джучидские денги), на которых ставились последние."
    },
    {
      id: "rub",
      name_ru: "Монеты древнерусской чеканки (конец X - начало XI вв.)",
      centuries: ['X', 'XI'],
      authors: ['Рублев А.И.'],
      ISBN: "9789859029417",
      pages: 424,
      published: "Минск 2016",
      pdf: "http://ruslitvaorda.ru/rublev.pdf",
      description: "Каталог, в котором опубликованы около 930 монет Киевской Руси, чеканенных в периоды правления Владимира, Святоаполка и Ярослава, в конце X - начале XI вв., является самым полным корпусом всех известных экземпляров сребреников и златников со времен труда сотрудника Эрмитажа М. Сотниковой, вышедшего в 1995 году."
    },
    {
      id: "hpya",
      name_ru: "Региональная чеканка на русских землях под властью Великого Княжества Литовского (последняя треть XIV в.)",
      centuries: ['XIV'],
      authors: ['Гулецкий Д.В.', 'Петрунин К.М.', 'Яковлев А.В.'],
      ISBN: "978-5-4380-0261-1",
      pages: 296,
      published: "Санкт-Петербург 2022",
      pdf: null,
      description: "Данная работа обобщает результаты исследований чеканки на русских землях, планомерно присоединявшихся к Великому княжеству Литовскому на протяжении XIII-XIV столетий, под властью князей династии Гедиминовичей. В последней трети XIV века удельная чеканка по региональным стандартам получила широкое распространение, что отразилось в большом количестве памятников нумизматики, дошедших до наших дней. Было изучено несколько тысяч монет, составлены графические реконструкции более тысячи штемпельных сочетаний, между которыми выявлено большое количество взаимосвязей. Рассмотрены монеты Киевского, Брянского, Стародубского, Новгород-Северского, Карачевского, Новогрудского, Подольского, Волынского, Белзского княжеств, подражательный чекан Любутского Приочья, Курско-Белгородские подражания с территории будущей Яголдаевой тьмы."
    },
    {
      id: "hlit",
      name_ru: "Монеты Великого княжества Литовского (II половина XIV века – 1536)",
      centuries: ['XIV', 'XV', 'XVI'],
      authors: ['Гулецкий Д.В.'],
      ISBN: "978-985-7090-33-4",
      pages: 260,
      published: "Минск 2014",
      pdf: "http://ruslitvaorda.ru/hlit.pdf",
      description: "Новый каталог монет Великого Княжества Литовского. Его автор – Д. Гулецкий, известный в Беларуси исследователь, чья первая книга по нумизматике вышла в 2007 году. Наиболее подробный каталог монет ВКЛ 1370-1536 годов, написанный белорусским автором, который специализируется на монетах ВКЛ с 2006 года. В книге впервые подробно освещается чекан русских княжеств XIV века под властью Литвы. Автор стоит на позиции классификации раннего литовского чекана, предлагаемой украинскими и белорусскими исследователями. В книге прорисованы все известные штемпели надчеканов “Колюмны“ и «точки», а также все типы гербов на монетах Александра и Жигимонта Старого."
    }
]
